import {store} from '../../store'
import {httpgst} from '../../main'

const state = {}

const getters = {}

const actions = {
  get ({commit, dispatch}, payload) {
    let year = payload.event.context.year
    let params = {
      categoryId: payload.event.context.selectedCategory === -1 ? undefined : payload.event.context.selectedCategory,
      areaId: payload.event.context.selectedArea === -1 ? undefined : payload.event.context.selectedArea,
      projectId: payload.event.context.selectedProject === -1 ? undefined : payload.event.context.selectedProject,
      userId: payload.event.context.userCompanySelected === -1 ? undefined : payload.event.context.userCompanySelected
    }
    let statusId = 6
    let type = 'json'
    let url = `api/reports/by-employee/by-year/${year}/by-status/${statusId}/${type}`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params }, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  downloadFile ({commit, dispatch}, payload) {
    let params = {
      categoryId: payload.event.context.selectedCategory === -1 ? undefined : payload.event.context.selectedCategory,
      areaId: payload.event.context.selectedArea === -1 ? undefined : payload.event.context.selectedArea,
      projectId: payload.event.context.selectedProject === -1 ? undefined : payload.event.context.selectedProject,
      userId: payload.event.context.userCompanySelected === -1 ? undefined : payload.event.context.userCompanySelected
    }
    let year = payload.event.context.year
    let statusId = 6
    let type = 'download'
    let url = `api/reports/by-employee/by-year/${year}/by-status/${statusId}/${type}`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {responseType: 'blob', params}, options)
      .then(
        response => {
          commit('onDownloadReport', {event: payload.event, response: response})
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    let data = payload.response.data.data.reportData
    payload.event.context.expenses.employed = []
    payload.event.context.expenses.totales = {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      'total': 0
    }
    data.forEach((row, index) => {
      let user = {
        id: row.id,
        name: row.name,
        months: [],
        total: 0,
        subtotal: 0,
        totalTip: 0
      }
      for (let i = 0; i < 12; i++) {
        let temp = {
          month: i,
          sumtotal: 0,
          sumsubtotal: 0
        }
        let expenses = row.expenses.filter(item => item.items_group_year[i])
        if (expenses.length > 0) {
          expenses.forEach(element => {
            let sumtotal = parseFloat(element.items_group_year[i].sumtotal)
            let sumsubtotal = parseFloat(element.items_group_year[i].sumsubtotal)
            temp.sumtotal += sumtotal
            temp.sumsubtotal += sumsubtotal
            user.totalTip += element.total_amount_tip
          })
        }
        user.months.push(temp)
      }
      user.months.forEach(month => {
        user.total += month.sumtotal
      })
      payload.event.context.expenses.employed.push(user)
    })
    let expensesItems = payload.response.data.data.expensesItemsByMonth
    if (expensesItems !== null) {
      let months = Object.getOwnPropertyNames(expensesItems)
      let newItems = []
      for (let i = 0; i < months.length; i++) {
        const item = months[i]
        if (item !== '0') {
          let temp = {
            month: parseInt(item),
            items: expensesItems[item]
          }
          newItems.push(temp)
        }
      }
      expensesItems = newItems
    }
    payload.event.context.expensesItems = expensesItems
    payload.event.context.show = true
    payload.event.context.disabled = false
    payload.event.context.loading = false
    payload.event.context.dialog = false
    payload.event.context.loadingItems = false
  },
  onDownloadReport (state, payload) {
    let date = payload.event.context.getReportDate()
    payload.event.context.forceFileDownload(payload.response.data, `AnnualExpensesUser ${payload.event.context.year} ${date}.xlsx`)
    payload.event.context.loadingDownload = false
  },
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.disabled = false
    payload.event.context.loadingItems = false
    payload.event.context.loadingDownload = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/annualExpensesByEmployedReport.js